import React, { useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

function FaqService({ title, disc }) {
  const [active, setActive] = useState(false);
  return (
    <div className='flex justify-end'>
      <div
        onMouseEnter={() => setActive(true)}
        onMouseLeave={() => setActive(false)}
        className={`flex items-center bg-white/60 p-6 hover:pr-20 hover:cursor-pointer mb-0.5 ml-5 sm:ml-0 w-[90%] sm:w-1/2 ${
          active ? "w-full sm:w-[60%]" : "w-[90%] sm:w-[50%]"
        } transition-all duration-[0.5s] ease-in-out`}
      >
        <div className='text-primary text-2xl'>
          {active ? <IoIosArrowBack /> : <IoIosArrowForward />}
        </div>
        <div>
          <div className='p-3.5'>
            <h1 className='text-2xl text-primary'>{title}</h1>
            <p className='text-gray-500'>{disc}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqService;
